import React, { createContext, useState, ReactNode } from 'react';

interface SearchContextType {
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  searchNotesQuery: string;
  setSearchNotesQuery: React.Dispatch<React.SetStateAction<string>>;
  orderSearchId: string;
  setOrderSearchId: React.Dispatch<React.SetStateAction<string>>;
}

const SearchContext = createContext<SearchContextType>({} as SearchContextType);

interface SearchContextProviderObject {
  children: ReactNode;
}

export const SearchContextProvider: React.FC<SearchContextProviderObject> = ({
  children,
}) => {
  const [search, setSearch] = useState<string>('');
  const [orderSearchId, setOrderSearchId] = useState<string>('');
  const [searchNotesQuery, setSearchNotesQuery] = useState<string>('');

  return (
    <SearchContext.Provider
      value={{
        search,
        setSearch,
        searchNotesQuery,
        setSearchNotesQuery,
        orderSearchId,
        setOrderSearchId,
      }}>
      {children}
    </SearchContext.Provider>
  );
};

export default SearchContext;
